// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEntity } from '@backstage/plugin-catalog-react';
import { TileBoundary } from '../team-landing/TileBoundary';

const STORYBOOK_PATH = 'storybook.luminus.be/path';
const STORYBOOK_HOST = 'storybook.luminus.be/host';
const WEB_HOST = 'https://storybook.luminus.be';
const MOBILE_HOST = 'https://storybook-mobile.luminus.be';

const resolveHost = (
  hostAnnotation: string | undefined,
  tags: ReadonlyArray<string> | undefined,
): string => {
  if (hostAnnotation) return hostAnnotation.replace(/\/+$/, '');
  if (tags?.includes('mobile')) return MOBILE_HOST;
  return WEB_HOST;
};

const StorybookCardBody = () => {
  const { entity } = useEntity();
  const annotations = entity.metadata.annotations ?? {};
  const path = annotations[STORYBOOK_PATH];
  if (!path) return null;
  const host = resolveHost(annotations[STORYBOOK_HOST], entity.metadata.tags);
  const url = `${host}/?path=${encodeURIComponent(path)}`;
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={1}>
          <Typography variant="h6">Storybook</Typography>
          <Link
            href={url}
            target="_blank"
            rel="noreferrer"
            aria-label="Open Storybook in a new tab"
          >
            Open in new tab
          </Link>
          <Box
            sx={{
              border: 1,
              borderColor: 'divider',
              borderRadius: 1,
              overflow: 'hidden',
              height: 480,
            }}
          >
            <iframe
              title={`Storybook for ${entity.metadata.name}`}
              src={url}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
            />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export const StorybookCard = () => (
  <TileBoundary tool="Storybook">
    <StorybookCardBody />
  </TileBoundary>
);
